import { types } from '../reducers/backgroundFileReducer';

// eslint-disable-next-line import/prefer-default-export
export const createBackgroundFile = (values) => ({
  type: types.POST,
  payload: values,
});

export const updateBackgroundFile = (values) => ({
  type: types.PUT,
  payload: values,
});

export const removeBackgroundFile = (index) => ({
  type: types.DELETE,
  index,
});

export const resetBackgroundFile = () => ({
  type: types.RESET,
});

export { getDraftId } from '../reducers/backgroundFileReducer';
